import React from 'react';
import logo from './logo.svg';
import { Counter } from './features/counter/Counter';
import './App.css';
import SquidGame from './features/squid game/SquidGame';
import Privacy from './features/privacy';

function App() {
  return (
    <div className="App">
      <Privacy/>
      {/*
      <SquidGame />
      */}
    </div>
  );
}

export default App;
